import React from "react";
import UserDefaultAvatar from "assets/img/user.svg";

const useStyles = {
  root: {
    alignItems: "center",
    justifyContent: "center",
    margin: "8px 16px",
    display: "flex",
    padding: "10px 8px",
    color: "#A8CF45",
    wordSpacing: "1px",
  },
  status: {
    padding: "0 10px",
    textTransform: "capitalize",
  },
  avatar: {
    width: "25px",
    height: "25px",
    borderRadius: "50%",
  },
};

export default ({ message }) => {
  const classes = useStyles;

  const checkSrc = (e) => {
    e.target.src = UserDefaultAvatar;
  };

  return (
    <div style={classes.root}>
      <img
        onError={checkSrc}
        style={classes.avatar}
        src={
          message?.memberInformation?.state?.attributes?.avatar ??
          UserDefaultAvatar
        }
        alt={"user"}
      />
      <div style={classes.status}>
        {message?.memberInformation?.state?.attributes?.full_name}{" "}
        {message?.status} the Watercooler
      </div>
    </div>
  );
};
